import styles from "./promotionalbanner.module.css";

const PromotionalBanner = () => {
  return (
    <section className={styles.promotional__wrapper}>
      <div className={styles.overlay}></div>

      <div className={styles.promotional__content}>
        <div className={styles.inner}>
          {/* <h1>Hair Care Essentials</h1>
          <p>from World's No.1 Skin Care Brand</p>

          <button className={styles.promotional__button}>
            UPTO 20% OFF
          </button> */}
        </div>
      </div>
    </section>
  );
};

export default PromotionalBanner;